import { readonly, ref } from 'vue';

const is_open = ref(false);
const is_destructive = ref(false);
const custom_message = ref('');
const custom_header = ref('');
const custom_accept_label = ref('');
const custom_cancel_label = ref('');
const custom_max_width = ref('');
const object_name = ref('');
const base_z_index = ref(0);
let resolve_promise = null;

export default function useGlobalConfirm() {
  /**
   * @param {{ destructive?: boolean; message?: string; header?: string; object_name?: string; accept_label?: string; cancel_label?: string; max_width?: string }} options
   * @returns {Promise<boolean>}
   */
  const confirm = (options = {}) => {
    base_z_index.value = options.base_z_index ?? 0;
    is_open.value = true;
    is_destructive.value = options.destructive ?? false;
    custom_message.value = options.message ?? '';
    custom_header.value = options.header ?? '';
    object_name.value = options.object_name ?? '';
    custom_accept_label.value = options.accept_label ?? '';
    custom_cancel_label.value = options.cancel_label ?? '';
    custom_max_width.value = options.max_width ?? '';
    return new Promise((resolve) => {
      resolve_promise = resolve;
    });
  };

  const handleConfirm = () => {
    is_open.value = false;
    if (resolve_promise) {
      resolve_promise(true);
      resolve_promise = null;
    }
  };

  const handleCancel = () => {
    is_open.value = false;
    if (resolve_promise) {
      resolve_promise(false);
      resolve_promise = null;
    }
  };

  return {
    is_open: readonly(is_open),
    is_destructive: readonly(is_destructive),
    custom_message: readonly(custom_message),
    custom_header: readonly(custom_header),
    custom_accept_label: readonly(custom_accept_label),
    custom_cancel_label: readonly(custom_cancel_label),
    custom_max_width: readonly(custom_max_width),
    object_name: readonly(object_name),
    base_z_index: readonly(base_z_index),
    confirm,
    handleConfirm,
    handleCancel,
  };
}
